import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSolutionSection } from './components/PainSolutionSection';
import { CategoriesGrid } from './components/CategoriesGrid';
import { DetailedPacks } from './components/DetailedPacks';
import { PricingSection } from './components/PricingSection';
import { DeliverySection } from './components/DeliverySection';
import { TrustSignals } from './components/TrustSignals';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans bg-white selection:bg-brand-emerald/30 selection:text-brand-navy" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSolutionSection data-id="element-2" />
      <CategoriesGrid data-id="element-3" />
      <DetailedPacks data-id="element-4" />
      <PricingSection data-id="element-5" />
      <DeliverySection data-id="element-6" />
      <TrustSignals data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}